import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgService24H = (props) => (
  <SvgIcon {...props} title="Service24H">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.352.025C5.785.455 1.61 4.8 1.503 10.272l-.012.65-.16-.153c-.552-.533-1.365-.212-1.33.524.015.313.024.324.964 1.262.942.938.959.951 1.282.951.323 0 .34-.013 1.281-.951.94-.938.95-.95.965-1.262.035-.738-.779-1.056-1.334-.521l-.162.156v-.243c.004-2.595.94-4.85 2.745-6.613a8.984 8.984 0 0 1 11.645-.746c.533.401 1.056.334 1.293-.166.19-.401.06-.735-.43-1.096C16.296.622 13.672-.154 11.352.025ZM21.52 10.527c-.174.056-.241.116-1.088.967-.962.967-.947.946-.93 1.293.033.706.805.96 1.344.443l.15-.145v.244c-.002 3.081-1.387 5.787-3.855 7.529-3.06 2.161-7.283 2.15-10.32-.025l-.372-.266c-.599-.429-1.41.171-1.166.863.168.476 1.814 1.485 3.222 1.974 6.759 2.35 13.838-2.535 13.985-9.65l.013-.662.148.141c.348.334.785.364 1.114.076.223-.195.3-.583.175-.864-.087-.194-1.688-1.8-1.877-1.883a.93.93 0 0 0-.543-.035Z"
        fill="#017163"
      />
      <path
        d="M11.576 6.115a1.32 1.32 0 0 1 .17-.069c.149-.049.452-.03.604.037.108.048 5.32 4.364 5.453 4.516.467.532.048 1.412-.673 1.412-.337 0-.278.044-2.806-2.066A270.88 270.88 0 0 0 12 8.017c-.007 0-1.053.868-2.324 1.928-2.528 2.11-2.469 2.066-2.806 2.066-.72 0-1.14-.88-.673-1.412.07-.08 5.307-4.445 5.38-4.484ZM7.792 13.367a.853.853 0 0 1 .53-.475c.39-.128.858.079 1.037.458l.076.16v2.767h5.13V13.51l.076-.16c.312-.659 1.267-.651 1.564.012l.072.16-.008 1.57-.008 1.573-.07.195c-.199.542-.672.97-1.225 1.105-.217.053-5.715.053-5.932 0A1.782 1.782 0 0 1 7.81 16.86l-.071-.195-.008-1.573-.008-1.573.07-.152Z"
        fill="#017163"
      />
    </svg>
  </SvgIcon>
);

export default SvgService24H;
